import { render, staticRenderFns } from "./ReorderIndex.vue?vue&type=template&id=2f3aa43a&scoped=true&"
import script from "./ReorderIndex.vue?vue&type=script&lang=js&"
export * from "./ReorderIndex.vue?vue&type=script&lang=js&"
import style0 from "./ReorderIndex.vue?vue&type=style&index=0&id=2f3aa43a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3aa43a",
  null
  
)

export default component.exports